<template>
  <div class="jobs-list" v-loading="loader">
    <div style="display: flex; flex: 1;">
    <ImportFromExcelCompany/>
    </div>
    <el-checkbox v-model="option.enableSelectAll" @change="companyUpdate" style="margin-top: 10px">Разрешить выбор всех работников</el-checkbox>
    <el-checkbox v-model="option.enableCreateUser" @change="companyUpdate" style="margin-top: 10px">Разрешить создание работника из табеля</el-checkbox>
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="jobs"
      @change="saveIndex"
    >
      <div class="jobs-li" v-for="(job, index) in filteredList" :key="index">
        <div class="jobs-text">
          <i class="fa fa-align-justify handle"></i>
          <span>{{ job.name }}</span>
        </div>
        <router-link :to="`/dashboard/company/users/edit/${$route.params.id}/${job._id}`" key="1">
          <i class="fa fa-edit"></i>
        </router-link>
      </div>
    </draggable>

    <router-link :to="getUrl()" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import FilterSelect from '../../../../components/FilterSelect';
import TabelProxy from "../../../../proxy/TabelProxy";
import firebase from "firebase";
import _ from "lodash";
import ImportFromExcelCompany from "./ImportFromExcelCompany";


export default {
  name: 'UsersList',
  components: {ImportFromExcelCompany, FilterSelect, draggable},

  data() {
    return {
      loader: false,
      search: '',
      companies: [],
      jobs: [],
      option: {
        enableCreateUser: false,
        enableSelectAll: false,
        approveEditor: false
      }
    };
  },
  async mounted() {
    this.loader = true
    const proxy = new TabelProxy({})

    const response = await proxy.list(this.$store.state.project.id, this.$route.params.id)
    this.jobs = response.data
    this.fetchCompany()

    this.loader = false
  },

  methods: {
    companyUpdate() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.$route.params.id)
        .update({
          ...this.option
        })
    },
    async saveIndex(n) {
      const proxy = new TabelProxy({})
      let position = 'after'
      let targetId = null;

      if(n.moved.newIndex === 0) {
        position = 'before'
        targetId = this.jobs[1]._id
      } else  {
        targetId = this.jobs[n.moved.newIndex - 1]._id
      }

      await proxy.updateIndex( n.moved.element._id, targetId, position)
    },
    getUrl() {
      return `/dashboard/company/users/create/${this.$route.params.id}`
    },
    async fetchCompany() {
      this.loader = true;

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.$route.params.id).get()
        .then((subDoc) => {
            let _data = subDoc.data();
            this.option = {
              enableCreateUser: _data.enableCreateUser || false,
              enableSelectAll: _data.enableSelectAll || false
            }
        })
    },
  },

  computed: {
    filteredList() {
      return this.jobs.filter((job) => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.jobs-text {
  display: flex;
  align-items: center;

  .handle {
    margin-right: 30px;
  }
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    height: auto !important;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.checkbox-list {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;

  i {
    margin-right: 10px;
  }

  span {
    text-align: left;
    font-size: 14px;
    margin-left: 8px;
  }
}

.jobs-list {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/UsersList.vue